// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"onboarding_listContainer__34b76","step":"onboarding_step__29ioL","stepCompleted":"onboarding_stepCompleted__3gl_9"};